

























































import Vue from 'vue'
import Input from '@/components/shared/atoms/Input'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import CommonArrow from '@/components/shared/atoms/Icon/CommonArrow'
import Modal from '@/components/shared/atoms/Modal'
import SupportSearchContainer from '@/containers/Support/Search'
import CategoryLinks from '@/components/Support/CategoryLinks'

interface IData {
  showSupportSearchModal: boolean
}

export default Vue.extend({
  components: {
    Input,
    LinkButton,
    CommonArrow,
    Modal,
    SupportSearchContainer,
    CategoryLinks
  },
  data(): IData {
    return {
      showSupportSearchModal: false
    }
  },
  methods: {
    openSupportSearchModal() {
      this.showSupportSearchModal = true
    },
    closeSupportSearchModal() {
      this.showSupportSearchModal = false
    }
  }
})
